module.exports = __webpack_public_path__ + "img/prism_architecture.b994f6cd.png";